<template>
    <div class="row">
        <div class="col-md-12">
            <table class="table table-sm table-condensed table-hover">
                <thead>
                    <tr>
                        <th>Usuário</th>
                        <th>Data</th>
                        <th>Compra</th>
                        <th>Quantidade</th>
                        <th>Total</th>
                        <th>Status</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, i) in historicos" :key="i">
                        <td><span v-if="item.usuario">{{item.usuario.nome}}</span></td>
                        <td>{{formatDate(item.data)}}</td>
                        <td>{{item.compra}}</td>
                        <td>{{item.quantidade}}x</td>
                        <td>{{formatMoney(item.total)}}</td>
                        <td>{{item.status}}</td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <td colspan="6">
                            <pagination :pagination="paginationHistory" :amount="amount" :offset="amount"
                                @paginate="getHistory">
                            </pagination>
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                historicos: [],
                loading: false,
                paginationHistory: {
                    page: 0,
                },
                amount: 5,
            }
        },
        beforeMount() {
            
            
            this.getHistory();
        },
        watch: {
            $route(data) {
                this.$destroy();
            }
        },
        methods: {
            getHistory(payload) {
                let req = {};
                if (typeof payload != 'object') {
                    req.page = this.paginationHistory.page;
                    req.amount = parseInt(this.amount);
                } else {
                    req = payload;
                    this.amount = parseInt(req.amount);
                }
                req.id = this.$route.params.id;
                this.loading = true;
                this.$store.dispatch('getHistoryByEmpresa', req).then(response => {
                    this.historicos = response.data;
                    this.paginationHistory = response.pagination;
                    this.loading = false;
                });
            }
        }
    }
</script>